/**
 * Donation frequency options for recurring donations.
 * Matches backend enum: Levitate.Models.Enums.SubscriptionFrequency
 *
 * Note: The backend serializes enum values as strings (e.g., "Monthly", "Yearly")
 * rather than numeric values, so we use string enums to match the API response format.
 */
export enum DonationFrequency {
	Monthly = 'Monthly',
	Yearly = 'Yearly',
}
